import { useNavigate, useParams } from 'react-router-dom';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import IGridComponent from '../../../components/grid/i-grid.component';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { getMasterDataById } from '../../master-data/masterdata.services';
import { getAllPojo, getMasterPojoPrint, getPojoByMasterCode, mergePojo, saveMasterPojo } from '../order.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';
import { isEmpty, isNotEmpty } from '../../common/util.services';
import IButton from '../../../components/button/i-button.component';
import MasterPojoComponent from './master-pojo.component';
import PrintIcon from '@mui/icons-material/Print';
import { Box, IconButton, Stack } from '@mui/material';
import PDFMasterPojoComponent from './pdf-master-pojo.component';
import { HelpOutline } from '@mui/icons-material';
import { getEnquiryProduct } from '../../enquiry/enquiry.services';
import ProductDetailComponent from '../../enquiry/enq-product/product-detail.component';

const MergePojoComponent = (props: any) => {
  const navigate = useNavigate();
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [pojoData, setPojoData] = useState(rows); 
  const [loading, setLoading] = useState(true);
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [openPrint, setOpenPrint] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [openPrdDetail, setOpenPrdDetail] = useState(false);
  const [prdDetail, setPrdDetail] = useState(null);
  const [openMaster, setOpenMaster] = useState(false);
  const [masterPojoData, setMasterPojoData] = useState<any>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const param = useParams();
  const orderId = param.orderId;
  const columns: GridColDef[] = [
    { field: 'pojoCode', headerName: 'PO/JS', filterable: false, sortable: false, editable: false, width: 115,
      renderCell: (params) => { return <div className={isEmpty(params.row.pojoCode) ? "" : "cell-link"}
      onClick={() => { openPojoPage(params.row) }}> {isEmpty(params.row.pojoCode) ? 'NA' : params.row.pojoCode}</div> }},
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 350,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={0}>
                                <IconButton size="small" onClick={() => openPrdDetailPage(params.row.productId)}
                                  sx={{ p: 0.6, ml: -1 }}> <HelpOutline fontSize="small" color='secondary'/>
                                </IconButton>{params.row.product}</Stack>)
    },
    { field: 'inputCode', headerName: 'Input Code', filterable: false, sortable: false, editable: false, width: 100,
      renderCell: (params) => { return <div className={isEmpty(params.row.inputCode) ? "" : "cell-link"}
      onClick={() => { openSpecsPopup(params.row.inputCode, params.row.inputId) }}>
                      {isEmpty(params.row.inputCode) ? 'NA' : params.row.inputCode}</div>}},
    { field: 'outputDesc', headerName: 'Output Description', filterable: false, sortable: false, editable: false, width: 350,
      renderCell: (params) => { return isEmpty(params.row.outputDesc) ? 'NA' : params.row.outputDesc}},
    { field: 'supplier', headerName: 'Supplier', filterable: false, sortable: false, editable: false, width: 265,
      renderCell: (params) => { return isEmpty(params.row.supplier) ? 'NA' : params.row.supplier}},
    { field: 'masterPojo', headerName: 'Master PO/JS', filterable: false, sortable: false, editable: false, width: 125,
      renderCell: (params) => {
        const handleTextClick = () => {
          openMasterPopup(params.row.masterPojo);
        };
        const handleIconClick = () => {
          printMasterPojo(params.row.masterPojo);
        };

        return (<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span onClick={handleTextClick}  style={{ cursor: isEmpty(params.row.masterPojo) ? '' : 'pointer', 
                                                          color: isEmpty(params.row.masterPojo) ? '' : 'blue',
                                                          textDecoration: isEmpty(params.row.masterPojo) ? '' : 'underline' }}>
                {isEmpty(params.row.masterPojo) ? 'NA' : params.row.masterPojo} </span>
                {isNotEmpty(params.row.masterPojo) && <IconButton size="small" onClick={handleIconClick}> 
                 <PrintIcon fontSize="small" color='secondary' /> </IconButton>}</Box>) }}
  ];

  const openPojoPage = (row: any) => {
    navigate('/order/pojo/list/' + row.linkId);
  }

  const onRowSelectionModelChange = (ids: any) => {
    const selectedIds = new Set(ids);
    const selectedRowData = pojoData.filter((row) =>
      selectedIds.has(row.rowId)
    );
    setSelectedRows(selectedRowData);
  }

  const closePrdDetail = () => {
    setOpenPrdDetail(false);
  }

  const openPrdDetailPage = (prdId: string) => {
    getEnquiryProduct(prdId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setPrdDetail(response.data);
        setOpenPrdDetail(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }

  const mergePojoData = () => {
    let pojoList: any = [];
    if(selectedRows.length <= 1) {
      appContext.setDialogMessage('Select multiple PO/JS to merge.');
      return;
    }

    let supplier = selectedRows[0].supplier;
    let pojoType = selectedRows[0].pojoType;
    let prevMpj = '';
    for(let i = 0; i < selectedRows.length; ++i) {
      if(selectedRows[i].supplier !== supplier) {
        appContext.setDialogMessage('Select PO/JS of same supplier to merge.');
        return;
      }

      if(selectedRows[i].pojoType !== pojoType) {
        appContext.setDialogMessage('Select either PO or JS to merge.');
        return;
      }

      if(isNotEmpty(selectedRows[i].masterPojo)) {
        if(isEmpty(prevMpj)) {
          prevMpj = selectedRows[i].masterPojo;
        } else if(selectedRows[i].masterPojo !== prevMpj) {
          appContext.setDialogMessage('Selected PO/JS should have empty or same master PO/JS.');
          return;
        }
      }

      pojoList.push(selectedRows[i].rowId);
    }

    setLoading(true);
    mergePojo(pojoList, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        getAllPojoData();
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const printMasterPojo = (masterCode: any) => {
    getMasterPojoPrint(masterCode, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        setRowData(response.data);
        setOpenPrint(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const openMasterPopup = (masterCode: any) => {
    if(isNotEmpty(masterCode)) {
      setLoading(true);
      getPojoByMasterCode(masterCode, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          setMasterPojoData(response.data);
          setOpenMaster(true);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }

  const openSpecsPopup = (inputCode: any, inputId: any) => {
    if('NA' !== inputCode) {
      setLoading(true);
      getMasterDataById(inputId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          setSpecsData(response.data);
          setOpenSpecs(true);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  const closeMaster = () => {
    setOpenMaster(false);
  }

  const closePrint = () => {
    setOpenPrint(false);
  }

  const saveMaster = (value: any) => {
    if('Submit' === value) {
      saveMasterPojo(masterPojoData, appContext,
        (response: any) => {
          getAllPojoData();
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoading(false);
        });
    }
    setOpenMaster(false);
  }

  function getAllPojoData() {
    getAllPojo(orderId, appContext,
      (response: any) => {
        setPojoData(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        setLoading(false);
      });
  }

  useEffect(() => {
    getAllPojoData();
  }, []);

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={pojoData} columns={columns} loading={loading} maxHeight={550}
        showAddBtn={false} getRowId={(row: any) => row.rowId} hideFooter={true} checkboxSelection={true}
        disableRowSelectionOnClick={true} rowSelectionModelChange={onRowSelectionModelChange} showExtraText={true}
        extraText={'Order Code: ' + (isEmpty(pojoData) || isEmpty(pojoData[0]) ? 'NA' : pojoData[0].orderCode)} extraTextColor='blue'/>
      <IButton label={'Merge'} onActionEvent={mergePojoData} />
      <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
        dialogBody={<SpecsComponent data={specsData} />} />
      <IDialogComponent onClose={closeMaster} open={openMaster} title='Master PO/JS'
        dialogBody={<MasterPojoComponent data={masterPojoData} close={saveMaster}/>} />
      <IDialogComponent onClose={closePrint} open={openPrint} title='Print Pojo'
        dialogBody={<PDFMasterPojoComponent data={rowData}/>} />
      <IDialogComponent onClose={closePrdDetail} open={openPrdDetail} title={'Product Details'}
        dialogBody={<ProductDetailComponent readOnly={true} data={prdDetail} close={closePrdDetail}/>} />
    </>
  }

  return <TitlePanel title={'Master PO/JS'} panelBody={getMainPanel()} />
}

export default MergePojoComponent;


